import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;
let accessToken = null;
let handlers = { onUser: null, onLogout: null, onReauth: null };

export const setAccessToken = (t) => { accessToken = t; };
export const setAuthHandlers = (h) => { handlers = { ...handlers, ...h }; };

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  if (accessToken) c.headers.Authorization = `Bearer ${accessToken}`;
  return c;
});

let refreshing = null;
export async function refreshSession() {
  refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
  const { data } = await refreshing;
  accessToken = data.access_token;
  return data;
}

api.interceptors.response.use((r) => r, async (err) => {
  const orig = err.config || {};
  const status = err.response?.status;
  const detail = err.response?.data?.detail;
  if (status === 401 && !orig._retry && !orig.skipRefresh) {
    orig._retry = true;
    try {
      const data = await refreshSession();
      handlers.onUser?.(data.user);
      return api(orig);
    } catch (e) {
      handlers.onLogout?.();
    }
  }
  if (status === 403 && detail?.code === "reauth_required" && !orig._reauthed && handlers.onReauth) {
    const ok = await handlers.onReauth();
    if (ok) { orig._reauthed = true; return api(orig); }
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => {
    const field = (x?.loc || []).filter((p) => typeof p === "string" && p !== "body").pop();
    const msg = (x?.msg || "").replace(/^String should match pattern .*/, "has an invalid format").replace(/^Value error, /, "");
    return field ? `${field.replace(/_/g, " ")}: ${msg}` : msg || JSON.stringify(x);
  }).join(". ");
  if (d.message) return d.message;
  if (d.errors || d.missing_documents) {
    const parts = Object.values(d.errors || {});
    if (d.missing_documents?.length) parts.push(`Missing documents: ${d.missing_documents.join(", ")}`);
    return parts.join(" · ") || "Validation failed";
  }
  return String(d);
}

export async function openFile(fileId) {
  const { data, headers } = await api.get(`/files/${fileId}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([data], { type: headers["content-type"] }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-PH", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const peso = (n) => (n == null ? "—" : `₱${Number(n).toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
